import { ModalViewer } from "@/components/ui/modal-viewer";
import { useVisorDocumento } from "@/hooks/useVisorDocumento";

/**
 * Instancia única del visor de documentos (se monta en `App.tsx`). Las pantallas no la montan:
 * llaman `verDocumento(url, titulo)` de `@/hooks/useVisorDocumento`.
 */
export function VisorDocumentoGlobal() {
  const url = useVisorDocumento((s) => s.url);
  const titulo = useVisorDocumento((s) => s.titulo);
  const cerrar = useVisorDocumento((s) => s.cerrar);
  return (
    <ModalViewer
      open={!!url}
      onOpenChange={(abierto) => { if (!abierto) cerrar(); }}
      url={url ?? ""}
      title={titulo}
    />
  );
}
